import React from 'react';
import Pulse from '@components/ui/Pulse';
import { LocationPulsePropsInterface } from './LocationPulseTypes';

function LocationPulse({
  text,
  isPulse = true,
  isInactive = false,
}: LocationPulsePropsInterface) {
  if (!text) {
    return null;
  }

  return (
    <Pulse
      label={{
        size: 'sm',
        text,
        color: isInactive ? 'neutral-default' : 'neutral-strong',
        weight: isInactive ? 'bold' : 'medium',
      }}
      icon={{ isPulse, color: 'green' }}
      inactive={isInactive}
    />
  );
}

export default LocationPulse;
